export const Error = () => {
  return <h1>Sorry! This page doesn't exist yet or is in progress.</h1>;
};
